import { render, staticRenderFns } from "./IconSendPlane.vue?vue&type=template&id=11f2b955&"
import script from "./IconSendPlane.vue?vue&type=script&lang=js&"
export * from "./IconSendPlane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports